module.exports = __webpack_public_path__ + "img/balloon.f08a3aa3.svg";